import React from 'react';
import {Link} from 'react-router-dom';
import './Card.css';

const Card = (props) => (
  <div className="col-md-3 fade-in mobile" style={{backgroundColor:'white',margin:'-0.5%', padding:'1%', paddingBottom:'20px'}}>
		<div className="single-blog" style={{margin: '0px', minHeight: '500px', maxHeight: '500px', overflow: 'hidden'}}>
		<Link to={{ pathname: `/noticia/${props.id}`, state: { props } }} className="flacso-verde view-more-btn">
			<figure>
				<div className="blog-thumb">
					<img src={props.image} alt="Flacso" className="width-100 img-responsive img-format" style={{maxHeight: '200px'}}/>
				</div>
				<figcaption>
					<ul className="list-unstyled">
						<li>{props.date}</li>
            <li></li>
					</ul>
				</figcaption>
			</figure>
			<div className="blog-excerpt">
				<h3 className="flacso-verde">{props.title}</h3>
        <p dangerouslySetInnerHTML={{ __html: props.description.slice(0, 200) + "..." }}/>
			</div>
			</Link>
		</div>
	</div>
);

export default Card;
